export const SCRIPT_URLS = {
  production: 'https://www.paypal.com/web-sdk/v6/core',
  test: 'https://www.sandbox.paypal.com/web-sdk/v6/core',
};

export const FLOW = {
  PAYMENT: 'payment',
  VAULT: 'vault',
};
